module.exports = __webpack_public_path__ + "static/img/2.322a937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newOne/2.png
// module id = j+n/
// module chunks = 0